export interface Movie {
  id: string;
  title: string;
  type: 'movie' | 'series' | 'short';
  typeLabel: string;
  region: string;
  year: number;
  duration: string;
  rating: number;
  genres: string[];
  director: string;
  cast: string[];
  synopsis: string;
  poster: string;
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: '1',
    title: '午夜追凶',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2024,
    duration: '118分钟',
    rating: 8.7,
    genres: ['悬疑', '犯罪'],
    director: '陈越',
    cast: ['江屹', '苏婉宁', '林浩然'],
    synopsis: '一名刑警在午夜接连接到神秘的报案电话，线索指向十二年前一桩悬而未决的旧案。随着调查深入，他发现真相比想象中更接近自己。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%20for%20a%20midnight%20crime%20thriller%2C%20lonely%20detective%20silhouette%20under%20rainy%20street%20lamps%2C%20deep%20midnight%20navy%20blue%20tones%20with%20warm%20amber%20highlights%2C%20dramatic%20moody%20lighting%2C%20atmospheric%20film%20noir%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-01&orientation=portrait',
    featured: true,
  },
  {
    id: '2',
    title: '星际回声',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2023,
    duration: '142分钟',
    rating: 9.1,
    genres: ['科幻', '冒险'],
    director: 'Ethan Cole',
    cast: ['Marcus Reed', 'Ava Sinclair', 'Leo Grant'],
    synopsis: '人类首支深空探险队抵达遥远星系，却收到一段来自未来的神秘回声。为了回家，他们必须解开回声隐藏的真相。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20facing%20a%20colossal%20glowing%20planet%20ring%2C%20deep%20navy%20and%20amber%20color%20palette%2C%20volumetric%20light%20rays%2C%20epic%20space%20atmosphere%2C%20high%20detail%20rendering%2C%20no%20text&width=600&height=900&seq=mv-poster-02&orientation=portrait',
    featured: true,
  },
  {
    id: '3',
    title: '深海迷航',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2024,
    duration: '126分钟',
    rating: 8.4,
    genres: ['科幻', '惊悚'],
    director: 'Nathan Brooks',
    cast: ['Chloe Hart', 'Devin Park'],
    synopsis: '一支深海勘探队在万米海沟发现未知信号源，随着下潜深度增加，船员们开始面对来自深渊的恐惧。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20deep%20sea%20sci-fi%20poster%2C%20submarine%20descending%20into%20dark%20ocean%20trench%2C%20bioluminescent%20lights%2C%20deep%20midnight%20blue%20with%20amber%20accents%2C%20dramatic%20underwater%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-03&orientation=portrait',
  },
  {
    id: '4',
    title: '孤城落日',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2022,
    duration: '134分钟',
    rating: 8.9,
    genres: ['剧情', '历史'],
    director: '周牧之',
    cast: ['段志远', '薛青衣', '罗嘉'],
    synopsis: '边缘小城在时代浪潮中迎来最后的黄昏，一位老守城人与返城的女儿在落日余晖里重新拾起被遗忘的往事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20historical%20drama%20poster%2C%20ancient%20lone%20city%20gate%20at%20golden%20sunset%2C%20warm%20amber%20sky%20against%20deep%20navy%20shadows%2C%20painterly%20epic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-04&orientation=portrait',
    featured: true,
  },
  {
    id: '5',
    title: '东京迷雾',
    type: 'movie',
    typeLabel: '电影',
    region: '日本',
    year: 2023,
    duration: '112分钟',
    rating: 8.2,
    genres: ['悬疑', '剧情'],
    director: '佐藤悠介',
    cast: ['高桥莲', '中村咲', '小林凉'],
    synopsis: '一名记者在霓虹与浓雾交织的都市里追查失踪案，镜面般的世界让他逐渐分不清记忆与真相。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20poster%2C%20foggy%20neon%20Tokyo%20alley%20at%20night%2C%20lone%20figure%20with%20umbrella%2C%20deep%20navy%20haze%20with%20amber%20neon%20reflections%2C%20moody%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-05&orientation=portrait',
  },
  {
    id: '6',
    title: '暗夜行者',
    type: 'movie',
    typeLabel: '电影',
    region: '港台',
    year: 2024,
    duration: '108分钟',
    rating: 8.5,
    genres: ['动作', '犯罪'],
    director: '麦定国',
    cast: ['郑家豪', '何芷晴'],
    synopsis: '一名卧底警员游走于黑白两道之间，当身份即将暴露，他必须在忠诚与生存之间做出抉择。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20crime%20poster%2C%20lone%20man%20in%20long%20coat%20walking%20down%20rainy%20neon%20street%2C%20deep%20midnight%20navy%20with%20amber%20street%20glow%2C%20gritty%20moody%20film%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-06&orientation=portrait',
  },
  {
    id: '7',
    title: '时间旅人',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2024,
    duration: '138分钟',
    rating: 8.8,
    genres: ['科幻', '爱情'],
    director: 'Olivia Grant',
    cast: ['Noah Bennett', 'Isla Moore'],
    synopsis: '一位物理学家意外掌握了穿越时间的能力，却发现自己每一次回溯都会让爱人离他更远。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20time%20travel%20romance%20poster%2C%20two%20figures%20separated%20by%20a%20glowing%20clock%20portal%2C%20deep%20navy%20backdrop%20with%20amber%20light%20trails%2C%20dreamy%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-07&orientation=portrait',
  },
  {
    id: '8',
    title: '无声告白',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2023,
    duration: '104分钟',
    rating: 8.0,
    genres: ['剧情', '爱情'],
    director: '许清和',
    cast: ['温言', '顾南', '白露'],
    synopsis: '一段始于沉默、终于告白的青春往事，两个不懂表达的人用二十年时间才读懂彼此。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20drama%20poster%2C%20two%20figures%20standing%20apart%20by%20a%20quiet%20lakeside%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20amber%20glow%2C%20soft%20melancholic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-08&orientation=portrait',
  },
  {
    id: '9',
    title: '荒原猎手',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2021,
    duration: '121分钟',
    rating: 7.9,
    genres: ['冒险', '西部'],
    director: 'Samuel Ford',
    cast: ['Jack Riley', 'Emma Cole'],
    synopsis: '在无边的荒原上，一名赏金猎人为追寻一个承诺踏上旅途，途中遇见了改变他一生的陌生人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20western%20adventure%20poster%2C%20lone%20rider%20on%20horseback%20crossing%20vast%20desert%20dunes%20at%20dusk%2C%20deep%20navy%20sky%20with%20amber%20horizon%20glow%2C%20epic%20lone%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-09&orientation=portrait',
  },
  {
    id: '10',
    title: '黑白之间',
    type: 'movie',
    typeLabel: '电影',
    region: '港台',
    year: 2022,
    duration: '115分钟',
    rating: 8.3,
    genres: ['犯罪', '剧情'],
    director: '邓立行',
    cast: ['伍国雄', '蔡若彤'],
    synopsis: '一位即将退休的法官在退休前夜收到一份匿名卷宗，一段被掩盖的真相让他重新审视一生的判决。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20drama%20poster%2C%20lone%20figure%20in%20courtroom%20shadows%2C%20deep%20navy%20darkness%20with%20amber%20light%20beam%2C%20tense%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-10&orientation=portrait',
  },
  {
    id: '11',
    title: '极光之约',
    type: 'movie',
    typeLabel: '电影',
    region: '日本',
    year: 2024,
    duration: '106分钟',
    rating: 8.1,
    genres: ['爱情', '剧情'],
    director: '山田葵',
    cast: ['松本遥', '井上千鹤'],
    synopsis: '两个在北极小镇相遇的旅人许下看一场极光的约定，多年后他们各自回到最初相遇的地方。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20poster%2C%20two%20silhouettes%20under%20aurora%20in%20snowy%20night%2C%20deep%20navy%20sky%20with%20amber%20and%20green%20aurora%2C%20dreamy%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-11&orientation=portrait',
  },
  {
    id: '12',
    title: '钢铁意志',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2021,
    duration: '148分钟',
    rating: 8.6,
    genres: ['战争', '剧情'],
    director: '马国栋',
    cast: ['贺远征', '秦铮', '石磊'],
    synopsis: '一场决定命运的战役中，一支小队在绝境里用意志守住了最后的阵地。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20war%20drama%20poster%2C%20soldiers%20silhouetted%20against%20smoky%20dawn%20horizon%2C%20deep%20navy%20shadows%20with%20amber%20firelight%2C%20epic%20solemn%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-12&orientation=portrait',
  },
  {
    id: '13',
    title: '幻影列车',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2023,
    duration: '119分钟',
    rating: 8.2,
    genres: ['悬疑', '惊悚'],
    director: 'Grace Hollow',
    cast: ['Ryan Cole', 'Nina Frost'],
    synopsis: '一列午夜驶出的列车没有终点，乘客们逐渐发现，下车的人将永远失去自己的记忆。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20suspense%20poster%2C%20old%20train%20emerging%20from%20night%20fog%2C%20deep%20midnight%20navy%20with%20amber%20window%20lights%2C%20eerie%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-13&orientation=portrait',
  },
  {
    id: '14',
    title: '我们的夏天',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2024,
    duration: '98分钟',
    rating: 7.8,
    genres: ['青春', '剧情'],
    director: '林小满',
    cast: ['夏知许', '陈屿', '安然'],
    synopsis: '高考结束的那个夏天，一群少年在离别与告白之间，留下了属于青春的最后一页。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20coming%20of%20age%20poster%2C%20group%20of%20teens%20on%20a%20seaside%20rooftop%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20amber%20glow%2C%20nostalgic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-14&orientation=portrait',
  },
  {
    id: '15',
    title: '暗流',
    type: 'series',
    typeLabel: '电视剧',
    region: '大陆',
    year: 2024,
    duration: '全32集',
    rating: 8.9,
    genres: ['悬疑', '犯罪'],
    director: '韩墨',
    cast: ['黎川', '宋知意', '方岩'],
    synopsis: '一桩看似普通的溺水案，牵出横跨政商两界的巨大暗流。老刑警与年轻检察官联手揭开层层迷雾。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20series%20poster%2C%20two%20figures%20facing%20a%20dark%20river%20under%20city%20lights%2C%20deep%20midnight%20navy%20with%20amber%20reflections%2C%20tense%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-15&orientation=portrait',
    featured: true,
  },
  {
    id: '16',
    title: '王座之影',
    type: 'series',
    typeLabel: '电视剧',
    region: '欧美',
    year: 2023,
    duration: '全24集',
    rating: 9.0,
    genres: ['奇幻', '剧情'],
    director: 'Arthur Vance',
    cast: ['Edward Hale', 'Clara Whitmore', 'Jonas Pike'],
    synopsis: '动荡大陆上，王座的阴影笼罩着七大家族，权力、誓言与荣耀交织成一场无法回头的博弈。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20fantasy%20series%20poster%2C%20lone%20ruler%20silhouette%20before%20a%20colossal%20throne%20hall%2C%20deep%20navy%20shadows%20with%20amber%20torch%20light%2C%20epic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-16&orientation=portrait',
    featured: true,
  },
  {
    id: '17',
    title: '城市之光',
    type: 'series',
    typeLabel: '电视剧',
    region: '大陆',
    year: 2024,
    duration: '全40集',
    rating: 8.2,
    genres: ['都市', '情感'],
    director: '苏以宁',
    cast: ['沈知夏', '陆屿', '纪蔓'],
    synopsis: '三个在不同楼层工作的都市人，在同一栋写字楼里交汇、错过，最终照亮彼此的生活。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20urban%20drama%20series%20poster%2C%20city%20skyline%20at%20night%20seen%20through%20glass%20tower%2C%20deep%20navy%20blue%20with%20warm%20amber%20window%20lights%2C%20modern%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-17&orientation=portrait',
  },
  {
    id: '18',
    title: '东京物语录',
    type: 'series',
    typeLabel: '电视剧',
    region: '日本',
    year: 2022,
    duration: '全12集',
    rating: 8.5,
    genres: ['家庭', '剧情'],
    director: '河合凉子',
    cast: ['山岸椿', '大野恒一'],
    synopsis: '一家开了五十年的旧书店里，店主用一本本旧书，记录下街坊邻里的悲欢与岁月。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20series%20poster%2C%20cozy%20old%20bookstore%20interior%20with%20warm%20lamplight%2C%20deep%20navy%20evening%20tones%20with%20amber%20glow%2C%20gentle%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-18&orientation=portrait',
  },
  {
    id: '19',
    title: '时间管理局',
    type: 'series',
    typeLabel: '电视剧',
    region: '欧美',
    year: 2024,
    duration: '全18集',
    rating: 8.7,
    genres: ['科幻', '悬疑'],
    director: 'Helen Cross',
    cast: ['Adam Reyes', 'Sofia Lane', 'Victor Ong'],
    synopsis: '一个隐藏于时间缝隙中的机构，负责修正被篡改的历史。新任探员却发现自己的过去早已被改写。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20series%20poster%2C%20agent%20standing%20before%20giant%20clockwork%20mechanism%2C%20deep%20navy%20tones%20with%20amber%20light%20rays%2C%20mysterious%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-19&orientation=portrait',
  },
  {
    id: '20',
    title: '边城故事',
    type: 'series',
    typeLabel: '电视剧',
    region: '港台',
    year: 2023,
    duration: '全26集',
    rating: 8.0,
    genres: ['剧情', '年代'],
    director: '关志强',
    cast: ['吴镇宇风', '李婉华'],
    synopsis: '小镇旅馆的老板见证了一批批来去匆匆的旅人，在时代变迁中守望着属于自己的那份坚持。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20period%20drama%20series%20poster%2C%20old%20town%20inn%20at%20dusk%20with%20warm%20lamp%20glow%2C%20deep%20navy%20evening%20blue%20with%20amber%20light%2C%20nostalgic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-20&orientation=portrait',
  },
  {
    id: '21',
    title: '迷雾侦探',
    type: 'series',
    typeLabel: '电视剧',
    region: '欧美',
    year: 2022,
    duration: '全20集',
    rating: 8.4,
    genres: ['悬疑', '推理'],
    director: 'Peter Lowe',
    cast: ['Daniel Ash', 'Mia Novak'],
    synopsis: '一位无法分辨人脸的天才侦探，凭借逻辑与直觉破获一桩桩离奇案件，却始终找不到自己的过去。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20detective%20mystery%20series%20poster%2C%20silhouette%20of%20detective%20in%20foggy%20street%20holding%20lantern%2C%20deep%20navy%20haze%20with%20amber%20glow%2C%20moody%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-21&orientation=portrait',
  },
  {
    id: '22',
    title: '山河故人录',
    type: 'series',
    typeLabel: '电视剧',
    region: '大陆',
    year: 2023,
    duration: '全36集',
    rating: 8.6,
    genres: ['历史', '剧情'],
    director: '裴文轩',
    cast: ['萧景琰', '温以宁', '柳云舒'],
    synopsis: '乱世之中，一群志士为了家国山河走到一起，用一生书写了一段荡气回肠的往事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20historical%20epic%20series%20poster%2C%20ancient%20warriors%20before%20misty%20mountains%20at%20dawn%2C%20deep%20navy%20shadows%20with%20amber%20sunrise%20glow%2C%20epic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-22&orientation=portrait',
  },
  {
    id: '23',
    title: '深夜食堂街',
    type: 'series',
    typeLabel: '电视剧',
    region: '日本',
    year: 2024,
    duration: '全16集',
    rating: 8.3,
    genres: ['治愈', '美食'],
    director: '森川直树',
    cast: ['藤井和也', '小泉纱良'],
    synopsis: '一条只在深夜营业的小食街，每一道菜背后都藏着一个客人的故事与心事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20healing%20food%20series%20poster%2C%20cozy%20late%20night%20street%20food%20stall%20with%20warm%20lanterns%2C%20deep%20navy%20night%20tones%20with%20amber%20glow%2C%20warm%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-23&orientation=portrait',
  },
  {
    id: '24',
    title: '硅谷风云',
    type: 'series',
    typeLabel: '电视剧',
    region: '欧美',
    year: 2023,
    duration: '全22集',
    rating: 8.1,
    genres: ['剧情', '商战'],
    director: 'Rachel Kim',
    cast: ['Tyler Woods', 'Elena Marsh'],
    synopsis: '一家濒临倒闭的创业公司，在两位理念相悖的创始人手中，卷入了科技巨头之间的激烈博弈。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20tech%20business%20drama%20series%20poster%2C%20silhouette%20before%20glowing%20server%20room%20corridor%2C%20deep%20navy%20blue%20with%20amber%20light%20streaks%2C%20modern%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-24&orientation=portrait',
  },
  {
    id: '25',
    title: '武林旧事',
    type: 'series',
    typeLabel: '电视剧',
    region: '大陆',
    year: 2022,
    duration: '全44集',
    rating: 8.5,
    genres: ['武侠', '古装'],
    director: '燕孤鸿',
    cast: ['沈墨白', '花见月', '秦无涯'],
    synopsis: '江湖传说早已远去，一名小人物却在偶然之间被卷入旧日恩怨，重拾失落的侠义之心。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20martial%20arts%20series%20poster%2C%20lone%20swordsman%20on%20a%20bamboo%20cliff%20under%20moonlight%2C%20deep%20navy%20night%20with%20amber%20moon%20glow%2C%20elegant%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-25&orientation=portrait',
  },
  {
    id: '26',
    title: '港岛往事',
    type: 'series',
    typeLabel: '电视剧',
    region: '港台',
    year: 2024,
    duration: '全30集',
    rating: 8.2,
    genres: ['年代', '剧情'],
    director: '何家声',
    cast: ['陈嘉乐', '袁咏仪珊'],
    synopsis: '从上世纪八十年代到今天，一个普通家庭在时代浪潮中的沉浮，记录下一座城市与一群人的记忆。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20period%20family%20series%20poster%2C%20old%20city%20street%20with%20vintage%20signs%20at%20dusk%2C%20deep%20navy%20shadows%20with%20amber%20neon%20glow%2C%20nostalgic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-26&orientation=portrait',
  },
  {
    id: '27',
    title: '一分钟惊魂',
    type: 'short',
    typeLabel: '短视频',
    region: '欧美',
    year: 2024,
    duration: '每集2分钟',
    rating: 7.9,
    genres: ['恐怖', '短剧'],
    director: 'Cole Dawson',
    cast: ['Ivy Brooks'],
    synopsis: '一分钟，一个反转。每集都在最短的时间里制造一次令人脊背发凉的惊魂时刻。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20horror%20short%20film%20poster%2C%20shadowy%20figure%20at%20the%20end%20of%20a%20dark%20hallway%2C%20deep%20navy%20blackness%20with%20eerie%20amber%20light%2C%20tense%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-27&orientation=portrait',
  },
  {
    id: '28',
    title: '都市速写',
    type: 'short',
    typeLabel: '短视频',
    region: '大陆',
    year: 2024,
    duration: '每集3分钟',
    rating: 7.7,
    genres: ['生活', '短剧'],
    director: '小圆',
    cast: ['阿哲', '西西'],
    synopsis: '用几分钟记录城市里的小瞬间：便利店、末班车、天台上的一场雨。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20urban%20lifestyle%20short%20poster%2C%20young%20person%20on%20a%20city%20rooftop%20at%20night%2C%20deep%20navy%20skyline%20with%20warm%20amber%20lights%2C%20fresh%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-28&orientation=portrait',
  },
  {
    id: '29',
    title: '猫与咖啡',
    type: 'short',
    typeLabel: '短视频',
    region: '日本',
    year: 2023,
    duration: '每集4分钟',
    rating: 8.1,
    genres: ['治愈', '日常'],
    director: '中川凪',
    cast: ['野田樱'],
    synopsis: '一间猫咖啡馆里，咖啡的香气与猫咪的呼噜声，治愈了每一位推门而入的客人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20healing%20slice%20of%20life%20short%20poster%2C%20cozy%20cat%20cafe%20interior%20with%20warm%20light%20and%20a%20cat%2C%20deep%20navy%20evening%20tones%20with%20amber%20glow%2C%20gentle%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-29&orientation=portrait',
  },
  {
    id: '30',
    title: '电梯惊魂',
    type: 'short',
    typeLabel: '短视频',
    region: '港台',
    year: 2024,
    duration: '每集2分钟',
    rating: 7.6,
    genres: ['惊悚', '短剧'],
    director: '彭子豪',
    cast: ['曾美欣'],
    synopsis: '电梯在十三楼停下的那一刻，门外的世界已经不属于她熟悉的一切。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20thriller%20short%20poster%2C%20lone%20woman%20inside%20dim%20elevator%20with%20flickering%20light%2C%20deep%20navy%20shadows%20with%20amber%20flicker%2C%20tense%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-30&orientation=portrait',
  },
  {
    id: '31',
    title: '霓虹夜话',
    type: 'short',
    typeLabel: '短视频',
    region: '大陆',
    year: 2023,
    duration: '每集5分钟',
    rating: 7.8,
    genres: ['文艺', '剧情'],
    director: '程一鸣',
    cast: ['祝晚', '林深'],
    synopsis: '深夜的霓虹灯下，两个陌生人在便利店门口聊起各自没能说出口的心事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20artsy%20short%20poster%2C%20two%20figures%20chatting%20under%20city%20neon%20signs%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20neon%20glow%2C%20moody%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-31&orientation=portrait',
  },
  {
    id: '32',
    title: '街角故事',
    type: 'short',
    typeLabel: '短视频',
    region: '欧美',
    year: 2022,
    duration: '每集6分钟',
    rating: 7.5,
    genres: ['剧情', '短剧'],
    director: 'Owen Blake',
    cast: ['Rosa Lane'],
    synopsis: '城市街角的咖啡馆，每天都有陌生人进来，留下一个短暂却动人的故事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20film%20poster%2C%20quiet%20street%20corner%20cafe%20at%20dusk%20with%20warm%20lamplight%2C%20deep%20navy%20evening%20tones%20with%20amber%20glow%2C%20warm%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-32&orientation=portrait',
  },
  {
    id: '33',
    title: '深夜电台',
    type: 'short',
    typeLabel: '短视频',
    region: '大陆',
    year: 2024,
    duration: '每集6分钟',
    rating: 8.0,
    genres: ['治愈', '剧情'],
    director: '洛以',
    cast: ['沈静姝'],
    synopsis: '一档只在凌晨三点播出的电台节目，主持人用声音陪伴着每一个失眠的听众。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20healing%20short%20poster%2C%20radio%20host%20in%20dim%20studio%20with%20warm%20lamp%2C%20deep%20navy%20night%20tones%20with%20amber%20glow%2C%20intimate%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-33&orientation=portrait',
  },
  {
    id: '34',
    title: '微光时刻',
    type: 'short',
    typeLabel: '短视频',
    region: '日本',
    year: 2023,
    duration: '每集4分钟',
    rating: 7.9,
    genres: ['励志', '剧情'],
    director: '木村悠真',
    cast: ['青木凛'],
    synopsis: '一个总在失败中跌倒的年轻人，在清晨第一缕阳光里，重新找到了出发的勇气。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20inspirational%20short%20poster%2C%20young%20person%20on%20a%20bridge%20at%20sunrise%2C%20deep%20navy%20tones%20with%20warm%20amber%20dawn%20light%2C%20hopeful%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-34&orientation=portrait',
  },
  {
    id: '35',
    title: '反转人生',
    type: 'short',
    typeLabel: '短视频',
    region: '大陆',
    year: 2024,
    duration: '每集3分钟',
    rating: 7.7,
    genres: ['喜剧', '短剧'],
    director: '赵小跑',
    cast: ['老王', '小李'],
    synopsis: '每天都有意想不到的反转，小人物的人生在几分钟里上演一出出哭笑不得的喜剧。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20short%20poster%2C%20playful%20cartoonish%20city%20scene%20at%20night%20with%20vivid%20signs%2C%20deep%20navy%20tones%20with%20bright%20amber%20accents%2C%20fun%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-35&orientation=portrait',
  },
  {
    id: '36',
    title: '雨夜来信',
    type: 'short',
    typeLabel: '短视频',
    region: '港台',
    year: 2023,
    duration: '每集5分钟',
    rating: 7.8,
    genres: ['悬疑', '剧情'],
    director: '邓小柔',
    cast: ['冯若初'],
    synopsis: '每逢雨夜，她都会收到一封没有署名的信，直到某一天，信里的预言成真了。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20short%20poster%2C%20lone%20woman%20reading%20a%20letter%20by%20a%20rainy%20window%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20lamp%20glow%2C%20moody%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-36&orientation=portrait',
  },
  {
    id: '37',
    title: '长夜将尽',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2024,
    duration: '116分钟',
    rating: 8.4,
    genres: ['悬疑', '剧情'],
    director: '顾长明',
    cast: ['季怀安', '叶澜'],
    synopsis: '一座即将拆迁的老楼里，六户人家在最后一个夜晚各自面对无法言说的秘密。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20drama%20poster%2C%20dim%20old%20apartment%20block%20at%20night%20with%20a%20single%20lit%20window%2C%20deep%20midnight%20navy%20tones%20with%20warm%20amber%20glow%2C%20quiet%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-37&orientation=portrait',
  },
  {
    id: '38',
    title: '风暴之子',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2023,
    duration: '129分钟',
    rating: 8.3,
    genres: ['动作', '冒险'],
    director: 'Liam Doyle',
    cast: ['Owen Stark', 'Ruby Hale'],
    synopsis: '一名退役飞行员为了拯救被困孤岛的城市，驾驶最后一架老旧飞机冲入风暴中心。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20adventure%20poster%2C%20lone%20aircraft%20flying%20into%20a%20massive%20storm%20cloud%2C%20deep%20navy%20sky%20with%20amber%20lightning%20glow%2C%20epic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-38&orientation=portrait',
  },
  {
    id: '39',
    title: '海上钢琴',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2022,
    duration: '132分钟',
    rating: 8.8,
    genres: ['剧情', '音乐'],
    director: 'Marco Bellini',
    cast: ['Antonio Russo', 'Clara Bell'],
    synopsis: '一位从未踏足陆地的钢琴师，一生都在邮轮上为过客演奏，直到最后一曲响起。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20musical%20drama%20poster%2C%20pianist%20silhouette%20before%20a%20grand%20piano%20in%20a%20dim%20ship%20hall%2C%20deep%20navy%20tones%20with%20warm%20amber%20spotlight%2C%20elegant%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-39&orientation=portrait',
  },
  {
    id: '40',
    title: '山海拾遗',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2024,
    duration: '124分钟',
    rating: 8.6,
    genres: ['奇幻', '冒险'],
    director: '白鹿鸣',
    cast: ['楚云归', '南星'],
    synopsis: '少女为寻找书中记载的失落山海，踏上穿越云海的旅程，一路上遇见传说中的异兽与故人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20fantasy%20adventure%20poster%2C%20lone%20traveler%20before%20floating%20mystic%20mountains%20above%20clouds%2C%20deep%20navy%20tones%20with%20amber%20glow%2C%20ethereal%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-40&orientation=portrait',
  },
  {
    id: '41',
    title: '樱花季',
    type: 'movie',
    typeLabel: '电影',
    region: '日本',
    year: 2023,
    duration: '110分钟',
    rating: 8.2,
    genres: ['爱情', '剧情'],
    director: '小林优子',
    cast: ['石川遥', '森下葵'],
    synopsis: '樱花盛开的一个月里，两个即将分别的年轻人在同一棵树下反复错过又重逢。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20poster%2C%20two%20figures%20under%20blooming%20cherry%20trees%20at%20dusk%2C%20deep%20navy%20evening%20tones%20with%20warm%20amber%20light%2C%20tender%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-41&orientation=portrait',
  },
  {
    id: '42',
    title: '九龙夜巡',
    type: 'movie',
    typeLabel: '电影',
    region: '港台',
    year: 2022,
    duration: '113分钟',
    rating: 8.5,
    genres: ['动作', '犯罪'],
    director: '严镇东',
    cast: ['高子杰', '古丽娜'],
    synopsis: '一名夜巡警员在一夜之间卷入黑帮交易与警队内斗，必须在黎明前找出真正的敌人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20crime%20poster%2C%20lone%20officer%20on%20a%20rainy%20neon%20city%20street%20at%20night%2C%20deep%20midnight%20navy%20with%20amber%20neon%20glow%2C%20gritty%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-42&orientation=portrait',
  },
  {
    id: '43',
    title: '量子边缘',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2024,
    duration: '140分钟',
    rating: 8.9,
    genres: ['科幻', '悬疑'],
    director: 'Nora Fields',
    cast: ['Elijah Stone', 'Hana Park'],
    synopsis: '一项量子实验让现实出现裂缝，科学家必须在两个世界彻底重叠前找到唯一的平衡点。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20thriller%20poster%2C%20figure%20before%20a%20fractured%20glowing%20quantum%20portal%2C%20deep%20navy%20tones%20with%20amber%20light%20shards%2C%20mind%20bending%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-43&orientation=portrait',
  },
  {
    id: '44',
    title: '归途列车',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2023,
    duration: '105分钟',
    rating: 8.1,
    genres: ['剧情', '公路'],
    director: '邱远',
    cast: ['许知远', '沈念'],
    synopsis: '一对多年未见的父女在同一趟返乡列车上重逢，漫长旅途里，他们重新拾起错过的岁月。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20road%20drama%20poster%2C%20old%20train%20crossing%20a%20vast%20winter%20plain%20at%20dusk%2C%20deep%20navy%20tones%20with%20warm%20amber%20window%20light%2C%20wistful%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-44&orientation=portrait',
  },
  {
    id: '45',
    title: '雪国来信',
    type: 'movie',
    typeLabel: '电影',
    region: '日本',
    year: 2021,
    duration: '118分钟',
    rating: 8.0,
    genres: ['剧情', '悬疑'],
    director: '青木原野',
    cast: ['佐久间凛', '宫本遥'],
    synopsis: '在大雪封山的小镇，一封迟到四十年的信，揭开了一段被所有人默契封存的往事。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20winter%20mystery%20drama%20poster%2C%20snowy%20mountain%20village%20at%20blue%20hour%20with%20warm%20window%20lights%2C%20deep%20navy%20tones%20with%20amber%20glow%2C%20quiet%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-45&orientation=portrait',
  },
  {
    id: '46',
    title: '烈焰审判',
    type: 'movie',
    typeLabel: '电影',
    region: '欧美',
    year: 2024,
    duration: '145分钟',
    rating: 8.7,
    genres: ['动作', '战争'],
    director: 'Victor Kane',
    cast: ['Aaron Blaze', 'Nadia Frost'],
    synopsis: '一支精英小队深入敌后执行秘密任务，代价却是他们必须亲手烧掉自己的过去。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20war%20poster%2C%20soldier%20silhouette%20before%20a%20burning%20horizon%20at%20night%2C%20deep%20navy%20shadows%20with%20amber%20firelight%2C%20intense%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-46&orientation=portrait',
  },
  {
    id: '47',
    title: '城南旧巷',
    type: 'movie',
    typeLabel: '电影',
    region: '大陆',
    year: 2022,
    duration: '101分钟',
    rating: 7.9,
    genres: ['剧情', '家庭'],
    director: '苏晚',
    cast: ['余秀兰', '周小满'],
    synopsis: '一条即将消失的老巷子里，祖孙三代用一个夏天完成了告别与和解。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20poster%2C%20old%20alley%20with%20warm%20lamps%20at%20dusk%20and%20a%20sitting%20elder%2C%20deep%20navy%20tones%20with%20amber%20glow%2C%20nostalgic%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-47&orientation=portrait',
  },
  {
    id: '48',
    title: '雾都夜行',
    type: 'movie',
    typeLabel: '电影',
    region: '港台',
    year: 2023,
    duration: '117分钟',
    rating: 8.3,
    genres: ['悬疑', '犯罪'],
    director: '霍家俊',
    cast: ['雷宇', '温碧珊'],
    synopsis: '每逢大雾，城市里就会发生一桩离奇案件，一位失眠的警探决定在下一次浓雾来临前找出真相。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20mystery%20poster%2C%20lone%20figure%20walking%20down%20a%20foggy%20city%20street%20at%20night%2C%20deep%20navy%20haze%20with%20amber%20neon%20glow%2C%20moody%20cinematic%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=mv-poster-48&orientation=portrait',
  },
];